import { getCurrentClientConfig } from '@/config/clients';

/**
 * Get client-specific color overrides dynamically from config
 * Uses dynamic registry without hardcoded conditions
 */
export const getClientColorOverrides = () => {
  const clientConfig = getCurrentClientConfig();

  if (!clientConfig.colorPaletteSrc) {
    return {};
  }

  try {
    // Load overrides using registry
    const overrides = clientConfig.colorPaletteSrc;

    return overrides;
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    console.warn(
      `⚠️ Color palette path not available, using default colors only:`,
      errorMessage
    );
    return {}; // Return empty object - will use default palette alone
  }
};
